import { render, staticRenderFns } from "./PracticalTab.vue?vue&type=template&id=0625b0f3&scoped=true"
import script from "./PracticalTab.vue?vue&type=script&lang=ts"
export * from "./PracticalTab.vue?vue&type=script&lang=ts"
import style0 from "./PracticalTab.vue?vue&type=style&index=0&id=0625b0f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0625b0f3",
  null
  
)

export default component.exports